export default from './Customers';



// WEBPACK FOOTER //
// ./src/containers/Customers/index.js